/* eslint-disable react/style-prop-object */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CategoryFacet as HeadlessCategoryFacet,
  CategoryFacetValue,
} from "@coveo/headless";
import React, { Dispatch, FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveSalesforce,
  setActiveINET,
  setIsShowRecommendedForModel
} from "../../../../actions/searchBoxAction";
import {
  CategoryFacetAEMProductType,
  CategoryFacetAEMType, CategoryFacetINET,
  CategoryFacetSalesforce
} from "../../../../controllers/facetControllers";
import {
  CategoryAEMINET,
  CategoryAEMSalesforce,
  CategoryAEMProductType,
  CategoryAEMType,
} from "../../../../utils/utils";
import "../scss/Category.scss";

interface CategoryFacetProps {
  controller: HeadlessCategoryFacet;
  title?: string;
  field?: string;
  subtitle?: string;
  isActiveOKB?: boolean;
  setIsActiveOKB?: Dispatch<React.SetStateAction<boolean>>;
  isActiveINET?: boolean;
  setIsActiveINET?: Dispatch<React.SetStateAction<boolean>>;
  isActiveType?: boolean;
  setIsActiveType?: Dispatch<React.SetStateAction<boolean>>;
  isActiveProductType?: boolean;
  setIsActiveProductType?: Dispatch<React.SetStateAction<boolean>>;
  isActiveSalesforce?: boolean,
  setIsActiveSalesforce?: Dispatch<React.SetStateAction<boolean>>;
  currentCategoryFacet?:any
}

export const Category: FunctionComponent<CategoryFacetProps> = (props) => {
  const {
    controller,
    isActiveType,
    setIsActiveType,
    isActiveProductType,
    setIsActiveProductType,
    // setIsActiveOKB,
    // isActiveOKB,
  } = props;
  const [state, setState] = useState(controller.state);
  const [stateProductType, setStateProductType] = useState(
    CategoryFacetAEMProductType.state
  );
  const [stateSalesforce, setStateSalesforce] = useState(CategoryFacetSalesforce.state);
  const [stateType, setStateType] = useState(CategoryFacetAEMType.state);
  const [stateINET, setStateINET] = useState(CategoryFacetINET.state);
  const [renderProductType, setRenderProductType] = useState(false);
  const [renderSalesforce, setRenderSalesforce] = useState(false);
  const [renderINET, setRenderINET] = useState(false);
  const [renderType, setRenderType] = useState(false);
  const isActiveSalesforce = useSelector((state: any) => state.searchBoxReducer.isActiveSalesforce);
  const isActiveINET = useSelector((state: any) => state.searchBoxReducer.isActiveINET);
  const isShowRecommended = useSelector((state: any) => state.searchBoxReducer.isShowRecommended);
  const dispatch = useDispatch();
  useEffect(
    () => controller.subscribe(() => setState(controller.state)),
    [controller]
  );

  useEffect(() => {
    const url_string = decodeURI(window.location.href);
    const url = new URL(url_string);
    if (url.searchParams.get("q") && url.searchParams.get("productName")) {
      // check if the url is redirected from AEM FAQ Search Box
      controller.state.values.forEach((value: any) => {
        if (value.value === "Knowledge Base") {
          controller.toggleSelect(value);
        }
      });
    }
  }, []);

  useEffect(
    () =>
      CategoryFacetAEMProductType.subscribe(() => {
        if (isActiveProductType) {
          setRenderProductType(true);
          setStateProductType(CategoryFacetAEMProductType.state);
        } else {
          setRenderProductType(false);
        }
      }),
    [CategoryFacetAEMProductType.state.values.length, isActiveProductType]
  );

  useEffect(
    () =>
      CategoryFacetAEMType.subscribe(() => {
        if (isActiveType) {
          setRenderType(true);
          setStateType(CategoryFacetAEMType.state);
        } else {
          setRenderType(false);
        }
      }),
    [isActiveType]
  );

  useEffect(
    () =>
        CategoryFacetSalesforce.subscribe(() => {
          if (isActiveSalesforce) {
            setRenderSalesforce(true);
            setStateSalesforce(CategoryFacetSalesforce.state);
        } else {
            setRenderSalesforce(false);
        }
      }),
    [isActiveSalesforce]
  );

  function checkIsOs (value:any) {
    return (value.toLowerCase().startsWith("windows") ||
        value.toLowerCase().startsWith("mac") ||
        value.toLowerCase().startsWith("os ") ||
        value.toLowerCase().startsWith("linux"));
  }

  useEffect(
      () =>
          CategoryFacetINET.subscribe(() => {
            if (isActiveINET) {
              let isShowRecommendedForModel;
              let currentCategory: any = CategoryFacetINET?.state?.parents.filter((item: any) => item.state === "selected");
              if (currentCategory.length > 0) {
                currentCategory = currentCategory[0];
                if (checkIsOs(currentCategory.value)) {
                  if (currentCategory?.children?.length !== 0) {
                    isShowRecommendedForModel = currentCategory.path[currentCategory.path.length - 2];
                  } else {
                    isShowRecommendedForModel = currentCategory.path[currentCategory.path.length - 3];
                  }
                }
                let checkOS = currentCategory?.children?.filter((item: any) => {
                  return checkIsOs(item.value);
                })
                if (!isShowRecommendedForModel && checkOS && checkOS.length > 0) {
                  isShowRecommendedForModel = currentCategory.path[currentCategory.path.length - 1];
                }
              }
              // @ts-ignore
              if (window.isSortRecommended) {
                // @ts-ignore
                window.recommendedModel = isShowRecommendedForModel;
              } else {
                // @ts-ignore
                window.recommendedModel = false;
              }
              dispatch(setIsShowRecommendedForModel({value: isShowRecommendedForModel}));
              setRenderINET(true);
              setStateINET(CategoryFacetINET.state);
            } else {
              setRenderINET(false);
            }
          }),
      [isActiveINET]
  );

  function getUniqueKeyForValue(value: CategoryFacetValue) {
    return value.path.join(">");
  }

  const getTitleNameFilter = () => {
    const pillSelected = document.querySelector(".pill-item.selected");
    const pillName = pillSelected?.getAttribute("id");
    let defaultAll = "All Products"; // The default value is used in Affiliate store
    if (!props.currentCategoryFacet) {
        return defaultAll;
    }

    switch (props.currentCategoryFacet.value) {
      case "Support":
        defaultAll = "All Support Information";
        break;
      case "Learning":
        defaultAll = "All Learning Materials";
        break;
      case "Industries":
        defaultAll = "All Industries";
        break;
      case "Resources":
        defaultAll = "All Resources";
        break;
      case "Inspriation":
        defaultAll = "All Articles";
        break;
        case "Community":
            defaultAll = "All Community Information";
            break;
    }
    return defaultAll;
  };

  const handleClickClearButton = () => {
    controller.deselectAll();
    CategoryFacetAEMProductType.deselectAll();
    CategoryFacetAEMType.deselectAll();
    CategoryFacetSalesforce.deselectAll();
    CategoryFacetINET.deselectAll();
    if (setIsActiveType) setIsActiveType(false);
    if (setIsActiveProductType) setIsActiveProductType(false);
    dispatch(setActiveSalesforce({value: false}));
    dispatch(setActiveINET({value: false}));
  };

  function renderClearButton() {
    const title = getTitleNameFilter();
    return (
        <div className={"allCategories" + (state.hasActiveValues ? " allCategories-active" : "")}
           style={{cursor: state.hasActiveValues ? "pointer" : "default"}}
           onClick={() => {
            if (state.hasActiveValues) {
              handleClickClearButton();
            }
           }}
      >
        {title}
      </div>
    );
  }

  function renderParents() {
    return (
        <div className="activeContentType">
          {renderClearButton()}
          {renderProductType &&
          CategoryFacetAEMProductType.state.hasActiveValues
            ? state.parents.map((parentValue, i) => {
                return (
                  <div key={getUniqueKeyForValue(parentValue)}>
                    <div
                      className="list-category-parent"
                      onClick={() => {
                        CategoryFacetAEMProductType.deselectAll();
                        controller.toggleSelect(parentValue);
                      }}
                    >
                      <span className="list-category-parent-label">{parentValue.value}</span>
                      <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                    </div>
                  </div>
                );
              })
            : renderType && CategoryFacetAEMType.state.hasActiveValues
            ? state.parents.map((parentValue, i) => {
                return (
                  <div key={getUniqueKeyForValue(parentValue)}>
                    <div
                      className="list-category-parent"
                      onClick={() => {
                        CategoryFacetAEMType.deselectAll();
                        controller.toggleSelect(parentValue);
                      }}
                    >
                      <span className="list-category-parent-label">{parentValue.value}</span>
                      <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                    </div>
                  </div>
                );
              })
            : renderINET && CategoryFacetINET.state.hasActiveValues
            ? state.parents.map((parentValue, i) => {
              return (
                  <div key={getUniqueKeyForValue(parentValue)}>
                    <div
                        className="list-category-parent"
                        onClick={() => {
                          CategoryFacetINET.deselectAll();
                          controller.toggleSelect(parentValue);
                          handleClick(parentValue);
                        }}
                    >
                      <span className="list-category-parent-label">{parentValue.value}</span>
                      <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                    </div>
                  </div>
              );
            })
            : renderSalesforce && CategoryFacetSalesforce.state.hasActiveValues
            ? state.parents.map((parentValue, i) => {
                return (
                  <div key={getUniqueKeyForValue(parentValue)}>
                    <div
                      className="list-category-parent"
                      onClick={() => {
                        CategoryFacetSalesforce.deselectAll();
                        controller.toggleSelect(parentValue);
                        handleClick(parentValue);
                      }}
                    >
                      <span className="list-category-parent-label">{parentValue.value}</span>
                      <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                    </div>
                  </div>
                );
              })
            : state.parents.map((parentValue, i) => {
                const isSelectedValue = i === state.parents.length - 1;
                return (
                  <div key={getUniqueKeyForValue(parentValue)}>
                    {!isSelectedValue ? (
                      <div
                        className="list-category-parent"
                        onClick={() => controller.toggleSelect(parentValue)}
                      >
                        <span className="list-category-parent-label">{parentValue.value}</span>
                        <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                      </div>
                    ) : (
                      <span className="category-selected">
                        <span className="category-selected-label">{parentValue.value}</span>
                        <span className="category-selected-number">({parentValue.numberOfResults})</span>
                      </span>
                    )}
                  </div>
                );
              })
          }
        </div>
    );
  }

  const handleClick = (value: CategoryFacetValue) => {
    controller.toggleSelect(value);
    if (value.value && CategoryAEMProductType.includes(value.value)) {
      if (setIsActiveProductType) setIsActiveProductType(true);
      if (setIsActiveType) setIsActiveType(false);
      dispatch(setActiveSalesforce({value: false}));
      dispatch(setActiveINET({value: false}));
      return;
    }
    if (value.value && CategoryAEMType.includes(value.value)) {
      if (setIsActiveProductType) setIsActiveProductType(false);
      if (setIsActiveType) setIsActiveType(true);
      dispatch(setActiveSalesforce({value: false}));
      dispatch(setActiveINET({value: false}));
      return;
    }
    if (value.value && CategoryAEMSalesforce.includes(value.value)) {
      dispatch(setActiveSalesforce({value: true}));
      dispatch(setActiveINET({value: false}));
      if (setIsActiveProductType) setIsActiveProductType(false);
      if (setIsActiveType) setIsActiveType(false);
      return;
    }
    if (value.value && CategoryAEMINET.includes(value.value)) {
      dispatch(setActiveSalesforce({value: false}));
      dispatch(setActiveINET({value: true}));
      if (setIsActiveProductType) setIsActiveProductType(false);
      if (setIsActiveType) setIsActiveType(false);
      return;
    }
  };

  function renderActiveValues() {
    var pillSelected = document.querySelector(".pill-item.selected");
    var pillName = pillSelected?.getAttribute("id");
    var filter = state.values;
    if (pillName?.toLowerCase() === "support"){
      filter = state.values.filter((value) => value.value.toLowerCase() !== "brochures");
    }
    return filter.map((value) => (
        <div className="categoy-label" key={getUniqueKeyForValue(value)}>
          <div
              className="list-category-child"
              style={state.hasActiveValues ? {} : { marginLeft: "0px" }}
              onClick={() => handleClick(value)}
          >
            <span className="list-category-child-label">{value.value}</span>
            <span className="list-category-child-number">({value.numberOfResults})</span>
          </div>
        </div>
    ));
  }

  function renderParentsAEMProductType() {
    return (
      stateProductType.hasActiveValues && (
        <div className="activeContentType">
          {stateProductType.parents.map((parentValue, i) => {
            const isSelectedValue = i === stateProductType.parents.length - 1;
            return (
              <div key={getUniqueKeyForValue(parentValue)}>
                {!isSelectedValue ? (
                  <div
                    className="list-category-parent"
                    onClick={() =>
                      CategoryFacetAEMProductType.toggleSelect(parentValue)
                    }
                  >
                  <span className="list-category-parent-label">{parentValue.value}</span>
                  <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                  </div>
                ) : (
                  <span className="category-selected">
                    <span className="category-selected-label">{parentValue.value}</span>
                    <span className="category-selected-number">({parentValue.numberOfResults})</span>
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )
    );
  }

  function renderActiveValuesAEMProductType() {
    return stateProductType.values.map((value) => (
      <div
        className="list-category-child d-type"
        key={getUniqueKeyForValue(value)}
        onClick={() => CategoryFacetAEMProductType.toggleSelect(value)}
      >
        <span className="list-category-child-label">{value.value}</span>
        <span className="list-category-child-number">({value.numberOfResults})</span>
      </div>
    ));
  }

  function renderParentsAEMSalesforce() {
    return (
        stateSalesforce.hasActiveValues && (
        <div className="activeContentType">
          {stateSalesforce.parents.map((parentValue, i) => {
            const isSelectedValue = i === stateSalesforce.parents.length - 1;
            return (
              <div key={getUniqueKeyForValue(parentValue)}>
                {!isSelectedValue ? (
                  <div
                    className="list-category-parent"
                    onClick={() => CategoryFacetSalesforce.toggleSelect(parentValue)}
                  >
                    <span className="list-category-parent-label">{parentValue.value}</span>
                    <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                  </div>
                ) : (
                  <span className="category-selected">
                    <span className="category-selected-label">{parentValue.value}</span>
                    <span className="category-selected-number">({parentValue.numberOfResults})</span>
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )
    );
  }
  function renderActiveValuesAEMSalesforce() {
    const allCategories = document.getElementsByClassName('allCategories');
    return (
      allCategories.length > 0 && ( stateSalesforce.values.map((value) => (
        <div
          className="list-category-child"
          key={getUniqueKeyForValue(value)}
          onClick={() => CategoryFacetSalesforce.toggleSelect(value)}
        >
          <span className="list-category-child-label">{value.value}</span>
          <span className="list-category-child-number">({value.numberOfResults})</span>
        </div>
      )))
    );
  }

  function categoryClick (value: any) {
    CategoryFacetINET.toggleSelect(value);
  }
  function renderParentsAEMINET() {
    return (
        stateINET.hasActiveValues && (
            <div className="activeContentType">
              {stateINET.parents.map((parentValue, i) => {
                const isSelectedValue = i === stateINET.parents.length - 1;
                return (
                    <div key={getUniqueKeyForValue(parentValue)}>
                      {!isSelectedValue ? (
                          <div
                              className="list-category-parent"
                              onClick={() => categoryClick(parentValue)}
                          >
                            <span className="list-category-parent-label">{parentValue.value}</span>
                            <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                          </div>
                      ) : (
                          <span className="category-selected">
                            <span className="category-selected-label">{parentValue.value}</span>
                            <span className="category-selected-number">({parentValue.numberOfResults})</span>
                          </span>
                      )}
                    </div>
                );
              })}
            </div>
        )
    );
  }
  function renderParentsAEMType() {
    return (
      stateType.hasActiveValues && (
        <div className="activeContentType">
          {stateType.parents.map((parentValue, i) => {
            const isSelectedValue = i === stateType.parents.length - 1;
            return (
              <div key={getUniqueKeyForValue(parentValue)}>
                {!isSelectedValue ? (
                  <div
                    className="list-category-parent"
                    onClick={() =>
                      CategoryFacetAEMType.toggleSelect(parentValue)
                    }
                  >
                     <span className="list-category-parent-label">{parentValue.value}</span>
                     <span className="list-category-parent-number">({parentValue.numberOfResults})</span>
                  </div>
                ) : (
                  <span className="category-selected">
                    <span className="category-selected-label">{parentValue.value}</span>
                    <span className="category-selected-number">({parentValue.numberOfResults})</span>
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )
    );
  }

  function renderActiveValuesAEMINET() {
    const allCategories = document.getElementsByClassName('allCategories');
    return (
        allCategories.length > 0 && ( stateINET.values.map((value) => (
            <div
                className="list-category-child"
                key={getUniqueKeyForValue(value)}
                onClick={() => categoryClick(value)}
            >
              <span className="list-category-child-label">{value.value}</span>
               <span className="list-category-child-number">({value.numberOfResults})</span>
            </div>
        )))
    );
  }

  function renderActiveValuesAEMType() {
    const allCategories = document.getElementsByClassName('allCategories');
    return allCategories.length > 0 && stateType.values.map((value) => (
      <div
        className="list-category-child"
        key={getUniqueKeyForValue(value)}
        onClick={() => CategoryFacetAEMType.toggleSelect(value)}
      >
        <span className="list-category-child-label">{value.value}</span>
        <span className="list-category-child-number">({value.numberOfResults})</span>
      </div>
    ));
  }
  let isMobileView = window.innerWidth < 768;
  return (
    <div id="facets" className={isMobileView ? " deactive":""}>
      {renderParents()}
      {renderActiveValues()}
      {renderSalesforce && renderParentsAEMSalesforce()}
      {renderSalesforce && renderActiveValuesAEMSalesforce()}
      {renderINET && renderParentsAEMINET()}
      {renderINET && renderActiveValuesAEMINET()}
      {renderProductType && renderParentsAEMProductType()}
      {renderProductType && renderActiveValuesAEMProductType()}
      {renderType && renderParentsAEMType()}
      {renderType && renderActiveValuesAEMType()}
    </div>
  );
};
